import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'shc-skeleton-loading',
  template: `<div
    [ngStyle]="{ width: width, height: height, 'border-radius': borderRadius }"
    class="skeleton-loader"
  ></div>`,
  styleUrls: ['./skeleton-loading.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule]
})
export class SkeletonLoadingComponent {
  @Input() width: string;
  @Input() height: string;
  @Input() borderRadius = '6px';
}
